<template>
    <login :statics="statics"></login>
</template>

<script>
import auth from '../auth'

export default {
    data() {
        return {
            statics: {
                logo: null,
                logo_inverse: null,
                logo_square: null,
                logo_square_inverse: null,
                host: null,
                referer: null,
                name: null,
                domain: null,
                whitelabel: false,
                path: null
            },
            loading_whitelabel: true,
        }
    },

    created() {
        this.getStatics()
    },

    methods: {
        getStatics() {
            this.loading_whitelabel = true
            axios.get('/get-statics')
                .then(res => {
                    this.statics = res.data
                    this.setPageTitle('Sign In - ' + this.statics.name + ' Admin')
                    this.loading_whitelabel = false
                })
                .catch(err => {
                    this.setPageTitle('Sign In - Aloware Admin')
                    console.log(err)
                    this.loading_whitelabel = false
                })
        },
    },

    beforeCreate() {
        document.body.className = 'blue-purple-gradient'
    },

    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next({name: 'Dashboard'})
            })
            .catch((err) => {
                next()
            })
    }
}
</script>
